import { useState } from 'react';
import { motion } from 'framer-motion';

interface Props {
  isBestValue?: boolean;
  firmId: string;
  affiliateLink?: string;
  code?: string | null;
  percent?: number | null;
  validUntil?: string | null;
  validUntilRemark?: string | null;
  firstPurchaseOnly?: boolean;
  className?: string;
  fee?: number;
}

export const PromoCTAButtonCompare = ({
  firmId,
  affiliateLink,
  code,
  percent,
  validUntil,
  validUntilRemark,
  firstPurchaseOnly,
  className = '',
  fee,
  isBestValue // ✅ added here
}: Props) => {
  const [revealed, setRevealed] = useState(false);
  const isPromoActive = !!code && !!percent;
  const handleReveal = () => setRevealed(true);
  let extraRemark = null;
  if (validUntilRemark) {
    extraRemark = validUntilRemark;
  } else if (typeof window !== 'undefined' && validUntil) {
    const date = new Date(validUntil);
    extraRemark = `Valid until ${date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })}`;
  } else if (firstPurchaseOnly) {
    extraRemark = 'Limited Offer';
  }
  const link = affiliateLink || `/go/${firmId}`;

  const discountedFee = fee && percent ? (fee * (1 - percent / 100)).toFixed(2) : null;

  return (
    <div className={`flex flex-col items-start gap-1 ${className}`}>
      {isPromoActive ? (
        <>
          <div className="flex items-center gap-2">
            {!revealed ? (
              <button
                title={extraRemark || undefined}
                aria-label={`Reveal promo code for ${firmId}`}
                onClick={handleReveal}
                className={`w-[140px] px-4 py-2 text-sm font-semibold text-black rounded transition text-center ${isBestValue ? 'bg-yellow-400 hover:bg-yellow-300' : 'bg-yellow-600 hover:bg-yellow-500'}`}
              >
                {percent ? `Claim ${percent}% OFF` : 'Claim Discount'}
              </button>
            ) : (
              <motion.a
                title={extraRemark || undefined}
                aria-label={`Use promo code ${code}`}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ scale: 0.95 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.2 }}
                className={`w-[140px] px-4 py-2 text-sm font-semibold text-black rounded transition text-center inline-block ${isBestValue ? 'bg-yellow-400 hover:bg-yellow-300' : 'bg-yellow-600 hover:bg-yellow-500'}`}
              >
                Use Code: {code}
              </motion.a>
            )}
          </div>
          <span className="text-xs text-yellow-300 mt-1 block">
            Save ${fee && discountedFee ? (fee - parseFloat(discountedFee)).toFixed(2) : '0.00'} now
          </span>
        </>
      ) : (
        <>
          <a
            aria-label={`Visit ${firmId} prop firm link`}
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="w-[140px] px-4 py-2 text-sm font-semibold text-white bg-gray-700 hover:bg-gray-600 rounded transition text-center inline-block"
          >
            Get Funded
          </a>
        </>
      )}
    </div>
  );
};

export default PromoCTAButtonCompare;